import { useRouteMatch } from 'react-router-dom'
import { BodyText } from '@calendly/ui/components/typography'
import { IconCreditCard } from '@calendly/ui/components/glyphs/IconCreditCard'
import { IconCalendar } from '@calendly/ui/components/glyphs/IconCalendar'
import { UiIcon } from '@calendly/ui/components/ui-icon'
const colorIconSecondary = 'var(--colorIconSecondary, var(--coreColorNeutral600))'
const colorBackgroundTertiary = 'var(--colorBackgroundTertiary, var(--coreColorNeutral300))'

import { useI18n } from 'locales'
import { formatCurrencyFromCents } from 'utils/currency'

import {
  Arrow,
  Header,
  Link,
  Marker,
  TitleContainer,
  Description,
  MetaRow,
  MetaItem,
} from './styles'

const PAYMENT_LINK_MARKER_COLOR = colorIconSecondary
const DEFAULT_MARKER_COLOR = colorBackgroundTertiary

const Package = ({
  color,
  name,
  description,
  url,
  offeringType,
  sessions,
  price,
  sessionPackageLabel,
}) => (
  <Link href={url} data-id="package">
    <Header>
      <Marker color={color} data-id="package-marker" />
      <TitleContainer data-id="package-header-title">
        <BodyText size="large" weight="bold">
          {name}
        </BodyText>
      </TitleContainer>
      <Arrow data-id="package-arrow" />
    </Header>
    <Description data-id="package-description">
      {description}
    </Description>
    <MetaRow data-id="package-meta">
      {offeringType === 'MEETING_PACKAGE' && sessions?.length > 0 && (
        <MetaItem>
          <UiIcon icon={IconCalendar} size="small" />
          <span>
            {`${sessions[0].num_units} ${sessionPackageLabel}`}
          </span>
        </MetaItem>
      )}
      {price && (
        <MetaItem>
          <UiIcon icon={IconCreditCard} size="small" />
          <span>{formatCurrencyFromCents(price.amount, price.currency)}</span>
        </MetaItem>
      )}
    </MetaRow>
  </Link>
)

export default function Packages({ offerings, isError }) {
  const { i18n } = useI18n()
  const profileSlug = useRouteMatch().params.profileSlug
  const sessionPackageLabel = i18n.t('booking.package.session_package')

  // Packages are an additive feature on the landing page. Fail open so a
  // failed packages fetch never blocks the rest of the landing page.
  if (isError) return null

  if (!offerings || offerings.length === 0) return null

  return offerings.map((offering) => {
    const isPaymentLink = offering.offering_type === 'PAYMENT_LINK'
    const color = isPaymentLink
      ? PAYMENT_LINK_MARKER_COLOR
      : (offering.color || DEFAULT_MARKER_COLOR)
    const segment = isPaymentLink ? 'payments' : 'packages'

    return (
      <Package
        key={offering.id}
        url={`/${profileSlug}/${segment}/${offering.id}`}
        color={color}
        name={offering.name}
        description={offering.description}
        offeringType={offering.offering_type}
        sessions={offering.sessions}
        price={offering.price}
        sessionPackageLabel={sessionPackageLabel}
      />
    )
  })
}
